import {FeesRepo} from '../fees.repo'
import {ExternalSourceName} from '../../common/enums/ExternalSources'
class ManagementFeeCashAccountController implements ng.IOnInit {

  public mcbCashAccounts ;
  public edrCashAccounts ;

  /** @ngInject */
  constructor(private feesRepo : FeesRepo, private iso4217: any){

  }

  $onInit() {
    this.getManagementFeeCashAccounts();
  }

  getManagementFeeCashAccounts = () => {
    this.feesRepo.getManagementFeeCashAccounts()
    .then(res => {
      let cashaccounts = res.data as Array<any>;

      this.mcbCashAccounts = cashaccounts.filter((account) => {
        return account.name == ExternalSourceName.MCB
      });

      this.edrCashAccounts = cashaccounts.filter((account) => {
        return account.name == ExternalSourceName.EDR
      });

    })
  }

  formatCurrencyCode = (currencyCode) => {
    if(currencyCode){
      return this.iso4217.getCurrencyByCode(currencyCode).symbol;
    }
    return null;
  }

}











export const managementFeeCashAccount : ng.IComponentOptions = {
  template : require('./fees.cashaccounts.html'),
  controller : ManagementFeeCashAccountController
}



// WEBPACK FOOTER //
// ./src/app/fees/cashAccounts/fees.cashaccounts.ts